import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \"List\"}}\n{{outlet}}",{ moduleName: "seshy/templates/authenticated/projects/show/project-versions/show/bounces/list.hbs" })